/* Scoped enhancement; standard Shopify product forms remain usable without JavaScript. */
(function () {
  'use strict';
  function initialise(root) {
    root.querySelectorAll('.ga-celebrity-shop form[data-gce-add]').forEach(function (form) {
      if (form.dataset.gceReady) return;
      form.dataset.gceReady = 'true';
      var selector = form.querySelector('[data-gce-variant]');
      if (selector) selector.addEventListener('change', function () {
        var option = selector.options[selector.selectedIndex];
        var price = form.closest('[data-gce-product]').querySelector('[data-gce-price]');
        if (option && option.dataset.price && price) price.textContent = option.dataset.price;
      });
      form.addEventListener('submit', async function (event) {
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        if (form.dataset.gcePending === 'true' || !form.reportValidity()) return;
        var button = form.querySelector('button[type="submit"]');
        var status = form.querySelector('.gce-product__status');
        var original = button.textContent;
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (!base.endsWith('/')) base += '/';
        var added = false;
        form.dataset.gcePending = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding…';
        status.textContent = '';
        try {
          var response = await fetch(base + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:new FormData(form)});
          if (!response.ok) {
            var problem = await response.json().catch(function () { return {}; });
            var error = new Error(problem.description || problem.message || 'This piece could not be added. Please check its product page.');
            error.confirmedFailure = true;
            throw error;
          }
          added = true;
          button.textContent = 'Added to bag';
          var link = document.createElement('a');
          link.href = base + 'cart';
          link.textContent = 'Added — view your bag';
          status.replaceChildren(link);
          try {
            var cartResponse = await fetch(base + 'cart.js', {credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
            if (!cartResponse.ok) throw new Error('Cart refresh unavailable');
            var cart = await cartResponse.json();
            var store = window.Alpine && typeof window.Alpine.store === 'function' ? window.Alpine.store('cart') : null;
            if (store) store.cartData = cart;
            document.dispatchEvent(new CustomEvent('ga:cart-updated', {detail:cart}));
            if (store) window.dispatchEvent(new CustomEvent('toggle-cart'));
          } catch (refreshError) {
            /* The add succeeded. Keep the bag link and never repeat the POST. */
          }
        } catch (error) {
          status.textContent = error.confirmedFailure ? error.message : 'We could not confirm the addition. Check your bag before trying again.';
          if (!error.confirmedFailure) {
            var checkLink = document.createElement('a');
            checkLink.href = base + 'cart';
            checkLink.textContent = ' View bag';
            status.appendChild(checkLink);
          }
        } finally {
          button.removeAttribute('aria-busy');
          var finish = function () { delete form.dataset.gcePending; button.disabled = false; button.textContent = original; };
          if (added) window.setTimeout(finish, 1300); else finish();
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  else initialise(document);
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
})();
